import { Entity, Field } from "typegraph";

// import Image from "../../entities/Image";
import Entry from "panels/organizations/admin/entities/Entry";

@Entity({one: "organization", many: "organizations"})
export default class OrganizationProducts {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field({entity: Entry})
	public entryList: Entry[];

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/entities/OrganizationProducts.ts